import { MeasureUnit } from '@domains/product';
import { Seo } from '@domains/seo';

import { KopecksIso } from '@utils/isomorph';

export const ORGANIZATION_LOGO_PATH = '/storage/uploads/mm/gurman_m.svg';

export const getOrganizationLogoUrl = (baseUrl: string | undefined): string =>
    `${baseUrl}${ORGANIZATION_LOGO_PATH}`;

/**
 * Экранирует `<` внутри JSON-строки перед вставкой в <script type="application/ld+json">.
 * Тег script — raw text element: выйти из него можно только последовательностью,
 * начинающейся с `<`, поэтому замены одного символа достаточно. `\u003c` — валидный
 * escape внутри JSON, при парсинге значение восстанавливается без потерь.
 */
export const escapeJsonLd = (json: string): string => json.replace(/</g, '\\u003c');

export const serializeJsonLd = (schema: unknown): string => escapeJsonLd(JSON.stringify(schema));

export const defaultSeoState: Seo = {
    title: null,
    image: null,
    description: null,
    keywords: null,
};

export const promoCatalogSeo: Seo = {
    title: 'Акции',
    description:
        'Все акции, специальные предложения на официальном сайте интернет-магазина Гурман-М. Гурман-М — премиальные продукты с доставкой по крупным городам Приморья',
    keywords:
        'гурман м, гурман м официальный сайт, гурман м владивосток, продукты для ресторанов, продукты для ресторанов и кафе, продукты оптом с доставкой, продукты оптом с доставкой приморский край',
    image: null,
};

export const newProductsCatalogSeo: Seo = {
    title: 'Новинки',
    description:
        'Все новинки на официальном сайте интернет-магазина Гурман-М. Гурман-М — премиальные продукты с доставкой по крупным городам Приморья',
    keywords:
        'гурман м, гурман м официальный сайт, гурман м владивосток, продукты для ресторанов, продукты для ресторанов и кафе, продукты оптом с доставкой, продукты оптом с доставкой приморский край',
    image: null,
};

export const makeMetaDescriptionForProduct = (name: string, measureUnit: MeasureUnit) => {
    const cleanedName = name.replace(/&nbsp;|\u00A0/g, ' ');

    return `Заказать ${cleanedName} c доставкой на дом во Владивостоке и Приморском крае. ${cleanedName} от ${KopecksIso.get(
        measureUnit.price_in_kopecks.new,
    )} ₽ / 1 ${measureUnit.type.name} в интернет-магазине «Гурман-М»`;
};
